import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

interface BarcodePreviewProps {
  svg: string | null;
  loading: boolean;
  error: string | null;
}

const BarcodePreview: React.FC<BarcodePreviewProps> = ({ svg, loading, error }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, bgcolor: '#fff', border: '1px solid #e0e0e0', borderRadius: 1 }}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, bgcolor: '#fff', border: '1px solid #e0e0e0', borderRadius: 1, p: 2 }}>
        <Typography color="error" variant="body2">{error}</Typography>
      </Box>
    );
  }

  if (!svg) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, bgcolor: '#fafafa', border: '1px dashed #ccc', borderRadius: 1, p: 2 }}>
        <Typography color="text.secondary" variant="body2">
          Skriv in ett EAN-13 nummer för att se förhandsgranskning
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
      bgcolor: '#d5d5d5',
      border: '1px solid #bdbdbd',
      borderRadius: 1,
      p: 3,
      '& svg': {
        maxWidth: '100%',
        height: 'auto',
      },
    }}>
      <div dangerouslySetInnerHTML={{ __html: svg }} />
    </Box>
  );
};

export default BarcodePreview;
